import React, { useState, useContext, useRef } from 'react';
import { SubscriptionsContext } from '../../contexts/Subscriptions'
import { HostContext } from '../../contexts/Host'
import { ShopContext } from '../../contexts/Shop'

export default function UpgradeTempAccess(props) {
  const subscriptions = useContext(SubscriptionsContext)
  const host = useContext(HostContext)
  const shop_name = useContext(ShopContext)

  const subscription = subscriptions.find((s) => s.id == props.subscription_id)

  const url = `${host}/enrollments/${subscription.enrollmentId}/upgrade`

  return (
    <form className="upgrade-temp-form" action={url} method="get">
      <input type="hidden" name="shop_name" value={shop_name} />
      <input type="submit" className="button orange registration-link" value="Upgrade" />
    </form>
  );
}
